(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["paper-sizing-guide"] && !Shopify.designMode) return;
  try {
    const bindPaperSizingGuideFocus = (scope = document) => {
    scope.querySelectorAll('.paper-sizing-guide').forEach((guide) => {
      if (!(guide instanceof HTMLElement) || guide.dataset.focusTargetBound === 'true') return;

      const dialogComponent = guide.closest('dialog-component');
      if (!dialogComponent) return;

      dialogComponent.addEventListener('dialog:open', () => {
        guide.focus({ preventScroll: true });
      });

      guide.dataset.focusTargetBound = 'true';
    });
  };

  bindPaperSizingGuideFocus();
  document.addEventListener('shopify:section:load', (event) => bindPaperSizingGuideFocus(event.target));
  } catch(e) { console.error(e); }
})();

})();
